<script setup lang="ts">
</script>

<template>
  <div class="flex items-center gap-4">
    <slot />
    <SiteNavCart />
    <SiteNavAccount />
    <SiteNavWishlist />
  </div>
</template>
